export default __webpack_public_path__ + "static/bpa-384df592cb484e35d34ee46e8255ea77.svg";